import { pathOr } from "ramda";

const state = {
  options: {}
};

const getters = {
  getOptionsSelected: state => code => {
    return pathOr(0, ["options", code], state);
  },
  getOptionsSelectedAll: state => {
    return state.options;
  }
};

const mutations = {
  setOptionsSelected: (state, payload) => {
    if (state.options.hasOwnProperty(payload)) {
      return;
    }
    const options = { ...state.options };
    options[payload] = true;
    state.options = options;
  },
  setOptionsSelectedAll: (state, payload) => {
    state.options = payload;
  }
};

const actions = {
  setOptionsSelected: ({ commit }, payload) => {
    commit("setOptionsSelected", payload);
  },
  setOptionsSelectedAll: ({ commit }, payload) => {
    commit("setOptionsSelectedAll", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
